/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 活动ID
   */
  event_id: string;
}
/**
 * 活动必填步骤
 */
export type ModuleList = {
  /**
   * 步骤名称，包括basic、guest、scheduler、ticket、register、publish
   */
  name: string;
}[];
/**
 * 高级玩法
 */
export type AdvancedList = {
  /**
   * 名称，包括register_question、approval、marketing
   */
  name: string;
}[];
export interface DashboardEventGetModulesRes {
  nonce?: string;
  msg?: string;
  code?: number;
  data: Data;
}
export interface Data {
  module_list: ModuleList;
  advanced_list: AdvancedList;
}

const DashboardEventGetModules = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<DashboardEventGetModulesRes>(
    '/wemeet-tapi',
    '/v2/activities/dashboard/event/get-modules',
    data,
    ctx,
  );

  return res;
};

export default DashboardEventGetModules;
